'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var React = require('react');
var dateTimeFieldContext = require('../dateTimeFieldContext.js');
var reactAria = require('react-aria');
var useNormalizedProps = require('../utils/useNormalizedProps.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
/**
 * useDateSegment
 *
 * Provides logic to render a date / time field segment. One segment represents  the day, month,
 * year, hour, minute, seconds, a separator or the time zone.
 * @param segment - The segment to render.
 * @param ref - Ref to the date segment.
 */
function useDateSegment(segment, ref) {
  var context = dateTimeFieldContext.useDateTimeFieldContext();
  var _useAriaDateSegment = reactAria.useDateSegment(segment, context.state, ref),
    segmentProps = _useAriaDateSegment.segmentProps;
  var normalizedSegmentProps = useNormalizedProps.useNormalizedDateSegmentProps(segment, segmentProps);
  var getHtmlProps = React.useCallback(function (givenProps) {
    return _objectSpread(_objectSpread(_objectSpread({}, normalizedSegmentProps), givenProps), {}, {
      children: segment.text
    });
  }, [segmentProps, segment.text]);
  return {
    getHtmlProps: getHtmlProps,
    context: context
  };
}
exports.useDateSegment = useDateSegment;